import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserI} from '../../../../interfaces/user.interface';
import { AppService } from '../../../../../../app.service';
import { AuthService } from '../../../../../../core/auth/auth.service';
import { DialogService } from '../../../../../../core/services/dialog.service';
import { RelatedCustomer, UserData } from '../../../../interfaces/user-data';
import {HistoryDialogComponent} from "./components/history-dialog/history-dialog.component";

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {

  userId: string;
  userData: UserData;
  relatedCustomers: RelatedCustomer[];
  suggestions: { name: string, external_id: string }[] = null;
  searchTimeout = null;

  public userDataForm = this.fb.group({
    user: this.fb.group({
      given_name: this.fb.control('', Validators.required),
      middle_name: this.fb.control(''),
      family_name: this.fb.control('', Validators.required),
      salut: this.fb.control('', Validators.required),
      email: this.fb.control('', Validators.required),
      valid: this.fb.control('', Validators.required),
      email_verified: this.fb.control('', Validators.required),
      newsletterOptIn: this.fb.control(''),
    })
  });


  public customerSearchForm = this.fb.group({
    input: this.fb.control(''),
    column: this.fb.control('external_id'),
  });

  constructor(private route: ActivatedRoute,
              public location: Location,
              public app: AppService,
              public fb: FormBuilder,
              private auth: AuthService,
              public dialog: DialogService) {
    this.userId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    this.getUserData();
  }

  getUserData(): void {
    if (this.userId) {
      this.app.dialog.loader({
        title: 'Laden von Nutzerdaten'
      });
      this.app.userData(this.userId).then(data => {
        // console.log(data);
        this.initUserForm(data.user);
        this.userData = data;
        this.getRelatedCustomers();
        this.app.dialog.closeLoader();
      });
    }
  }

  getRelatedCustomers() {
    const ids = {};
    if (this.userData.user && this.userData.user.claims) {
      this.userData.user.claims.forEach(c2u => {
        ids[c2u.external_customer_id] = c2u.external_customer_id;
      });
      this.app.relatedCustomers(Object.values(ids)).then(res => {
        this.relatedCustomers = res;
      })
    }
  }

  getSector() {
    let sector = 'Unbekannt';
    if(this.userData.user && this.userData.user.industrySector) {
      switch (this.userData.user.industrySector) {
        case 'politics':
          sector = 'Politik';
          break;
        case 'administration':
          sector = 'Verwaltung';
          break;
        case 'business':
          sector = 'Wirtschaft';
          break;
        default:
          sector = 'Unbekannt';
          break;
      }
    }
    return sector;
  }

  saveUser() {
    if (this.userDataForm.valid) {
      const user = Object.assign({}, this.userData.user);
      const userValues = (this.userDataForm.get('user') as FormGroup).value as { [key: string]: string | boolean };
      for (let k in userValues) {

        if (user.hasOwnProperty(k) && userValues.hasOwnProperty(k)) {
          user[k] = userValues[k];
        }
      }
      user.name = ([user['given_name'], user['middle_name'], user['family_name']]).join(' ').replace('  ', ' ');
      console.log(user);
      this.app.userUpdate(user, this.auth.user.id).then(res => {
        if (res) {
          this.userData.user = user;
          this.app.toast.open('Profil aktualisiert');
        }
      }).catch(err => {
        this.app.toast.open('Unbekannter Fehler', null, {
          panelClass: 'warn'
        });
      });
    } else {
      console.error('form invalid');
    }

  }

  initUserForm(user: UserI) {
    const userGroup = this.userDataForm.get('user') as FormGroup;
    if (user) {
      userGroup.get('given_name').setValue(user.given_name);
      userGroup.get('middle_name').setValue(user.middle_name);
      userGroup.get('family_name').setValue(user.family_name);
      userGroup.get('salut').setValue(user.salut);
      userGroup.get('email').setValue(user.email);
      userGroup.get('valid').setValue(user.valid || false);
      userGroup.get('email_verified').setValue(user.email_verified || false);
      userGroup.get('newsletterOptIn').setValue(user.newsletterOptIn || false);
    }
  }

  customerAction(data: { action: string, params: any }) {
    switch (data.action) {
      case 'addClaim2User':
        this.app.claim2userCreate({userId: this.userData.user.id, external_claim_id: data.params}).then(res => {
          console.log(res);
          this.getUserData();
        }).catch(() => {
          this.app.toast.open('Unbekannter Fehler', null, {
            panelClass: 'warn'
          });
        });
        break;
      case 'sendInvitation':
        this.app.newInvitation({userId: this.userData.user.id, c2cId: data.params}).then(res => {
          if (res) {
            this.app.toast.open('Einladungs-E-Mail wurde erfolgreich gesendet');
          }
        }).catch(() => {
          this.app.toast.open('Unbekannter Fehler', null, {
            panelClass: 'warn'
          });
        });
        break;
    }
  }

  hideSuggestions() {
    setTimeout(() => {
      this.suggestions = null;
    }, 500)
  }

  findCustomersLive() {
    const inp = this.customerSearchForm.value.input.trim();
    const column = this.customerSearchForm.value.column;
    clearTimeout(this.searchTimeout);
    if (column === 'name' && inp.length >= 4) {
      this.searchTimeout = setTimeout( () => {
        this.app.relatedCustomersLive(inp).then(res => {
          if (res && res.length) {
            console.log(res);
            this.suggestions = res;
          }
        })
      }, 850);
    }
  }

  passwordChangeRequest(btn?: any) {
    this.app.lostPassword(this.userData.user.email).then(res => {
      if (res) {
        this.app.toast.open(`Der Link zur Kennwortänderung wurde an den Benutzer (Email: ${this.userData.user.email}) gesendet.`);
        btn.disabled = true;
        setTimeout(() => {
          btn.disabled = false;
        }, 7000)
      }
    }).catch(err => {
      this.app.toast.open('Unbekannter Fehler', null, {
        panelClass: 'warn'
      });
    })
  }

  showHistory() {
    this.dialog.open(HistoryDialogComponent, {data: {user_id: this.userId}, width: '80%'});
  }

  findRelatedCustomer(id?: string) {
    if (!id) {
      id = this.customerSearchForm.value.input.trim();
    }

    if (id && id.length) {
      this.app.relatedCustomers([id]).then(customers => {
        if (customers && customers.length) {
          this.app.toast.open('Ein Kunde/Organisation gefunden');
          if (this.relatedCustomers) {
            customers.forEach(customer => {
              const found = this.relatedCustomers.find(c => c.external_id === customer.external_id);
              const index = this.relatedCustomers.indexOf(found);
              if (index > -1) {
                this.relatedCustomers[index] = customer;
              } else {
                this.relatedCustomers.push(...customers)
              }
            });
          } else {
            this.relatedCustomers = customers;
          }
        } else if (customers.length === 0) {
          this.app.toast.open('Keine Kunden/Organisationen gefunden');
        }
      })
    }
  }

}
